import { render } from "./appEduResearch.vue?vue&type=template&id=be5fe3f6&scoped=true"
import script from "./appEduResearch.vue?vue&type=script&lang=js"
export * from "./appEduResearch.vue?vue&type=script&lang=js"

import "./appEduResearch.vue?vue&type=style&index=0&id=be5fe3f6&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5fe3f6"]])

export default __exports__